import { gql } from '@apollo/client';
import { LanguageFragment } from 'graphql/Language/fragments/LanguageFragment';
/**
 * @fragment DealStageFragment
 * @since 1.0.0
 */
export const DealStageFragment = gql `
  fragment DealStageFragment on DealStage {
    id
    tag
    title
    position
    color
    updatable
    deletable

    translations {
      id
      title

      language {
        ...LanguageFragment
      }
    }
  }
  ${LanguageFragment}
`;
